import React from "react";
import DragAndDropUpload from "../DragAndDropUpload";
import Loader from "../loading";

const CustomFileInput = ({
  state,
  setState,
  id,
  label,
  objKey,
  imageType,
  isUploading,
  fullWidth,
  closeDialog,
  callback,
  myObjects
}) => {
  return (
    <div
      className={`fluid_left col-sm-12 ${
        fullWidth ? "col-md-12 px-0 ml-2 w-100" : "col-md-6"
      }`}
    >
      <div className="form-group">
        <label
          style={{
            color: "#000000",
            fontWeight: "bold",
            fontSize: "12px",
          }}
          className={`label w-100 mb-0 ${
            state.isUploaded ? "text-success" : "text-danger"
          }`}
          htmlFor="id"
        >
          {label}
          <span>*</span>
        </label>
        <DragAndDropUpload
          setState={setState}
          type={imageType}
          disabled={false}
          objKey={objKey}
          path=""
          closeDialog={closeDialog}
          callback={callback}
          myObjects={myObjects}
        />
        {/* <FileUploadComponent
          setFileInfo={setUtilityInfo}
          fineInfo={utilityInfo}
          type="Utility"
          disabled={false}
          path=""
          // setValidationErrors={setValidationErrors}
        /> */}
        {state?.successMsg && (
          <p style={{ fontSize: "12px" }} className="text-success">
            {state?.successMsg}
          </p>
        )}

        {state?.errorMsg && <p className="text-danger">{state?.errorMsg}</p>}
      </div>

      {isUploading ? (
        <Loader text="Waiting for upload" bgColor="rgba(0,0,0,0.12)" />
      ) : null}
    </div>
  );
};

CustomFileInput.defaultProps = {
  fullWidth: false,
};

export default CustomFileInput;
